/* eslint-disable @typescript-eslint/no-explicit-any */
import { useHeaderContext } from '@/sinister/header/contexts/HeaderContext'
import TextAtomic from '../../atomic/Text'
import styles from './Text.module.css'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Text = (props: any) => {
  const { colorHeader: color } = useHeaderContext()

  return (
    <TextAtomic
      className={styles.text}
      style={{ color: color || 'var(--color-white)' }}
      {...props}
    />
  )
}

export default Text
